import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";

const getRequiredStringValidation = (fieldName: string) => {
  const message = `${fieldName} is required`;
  return z.string({ required_error: message }).trim().min(1, { message });
};

const smsSimulatorFormSchema = z.object({
  client: z.object(
    {
      label: z.string(),
      value: z.string(),
    },
    { required_error: "Please select a client" },
  ),
  testSmsText: getRequiredStringValidation("Test SMS Text"),
  systemPrompt: getRequiredStringValidation("System Prompt"),
});

export const SMS_SIMULATOR_FORM_VALIDATION_SCHEMA = zodResolver(smsSimulatorFormSchema);

export type SmsSimulatorFormData = z.infer<typeof smsSimulatorFormSchema>;
